export const LANGUAGES = [
  { label: "العربية", code: "ar" },
  { label: "English", code: "en" },
  { label: "Frensh", code: "fr" },
];

// RTL languages
export const RTL_LANGUAGES = ["ar"];
